export enum CartItemStatus {
  Open = 'OPEN',
  Sold = 'SOLD',
  Returned = 'RETURNED',
}

export interface CartItem {
  id: number;
  cartId: number;
  productId: number;
  productOfferingId: number;
  quantity: number;
  tax: number;
  price: number;
  serialNumbers: ReadonlyArray<string>;
  status: CartItemStatus;
  downloadable: boolean;
}

export enum CartStatus {
  SessionCart = 'SESSION_CART',
  WishList = 'WISH_LIST',
  Hold = 'HOLD',
  Purchased = 'PURCHASED',
  COPending = 'CO_PENDING',
  POPending = 'PO_PENDING',
  Cancelled = 'CANCELLED',
}

export enum PaymentMethod {
  CreditCard = 'CREDIT_CARD',
  PurchaseCard = 'PURCHASE_CARD',
  CampusOrder = 'CAMPUS_ORDER',
  Free = 'FREE',
  UShopPurchaseOrder = 'USHOP_PURCHASE_ORDER',
}

export interface Cart {
  id: number;
  items: ReadonlyArray<CartItem>;
  unid: string;
  paymentMethod: PaymentMethod;
  statusDate: Date;
  status: CartStatus;
  deptId: string;
  comments: string;
  publicOslComments: string;
}

export interface CartTotals {
  subtotal: number;
  tax: number;
  total: number;
}
